import React from 'react';
import { SimpleSelect } from '../select';
import { IBrand } from '../../../libs/brand';

interface BrandSelectProps {
  onChange: (value: IBrand) => void;
  isLoading: boolean;
  brands: IBrand[];
  value?: string;
  fill?: boolean;
  disabled?: boolean;
  shouldAutoFit?: boolean;
}

const createOptions = (isLoading: boolean, brands: IBrand[]) => {
  if (isLoading) {
    return [
      {
        label: 'Loading...',
        value: '0'
      }
    ];
  }
  if (!brands || !brands.length) {
    return [
      {
        label: 'No brands found!',
        value: '0'
      }
    ];
  }
  const options = [
    {
      label: 'Select Chat Brand',
      value: '0'
    }
  ];
  for (const brand of brands) {
    options.push({
      label: brand.name,
      value: brand.id.toString()
    });
  }
  return options;
};

const BrandSelect = ({
  onChange,
  value,
  fill,
  isLoading,
  brands,
  disabled = false,
  shouldAutoFit = false
}: BrandSelectProps): JSX.Element => {
  const brandOptions = createOptions(isLoading, brands);

  const handleSelect = (evt: React.ChangeEvent<HTMLSelectElement>) => {
    if (evt.currentTarget.value === '0') {
      return;
    }
    const brandId = evt.currentTarget.value;
    const brand = brands.find((brand) => brand.id.toString() === brandId);
    onChange(brand);
  };

  return (
    <div className={shouldAutoFit ? 'w-auto' : ''}>
      <SimpleSelect
        aria-label="Select Brand"
        disabled={disabled}
        onChange={handleSelect}
        value={value}
        fill={fill}
        options={brandOptions}
      />
    </div>
  );
};

export default BrandSelect;
